import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import * as Icon from 'react-feather';

const ToggleMenuItem = ({ menu }) => {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);

    const toggleSection = () => {
        setIsOpen(!isOpen);
    };

    const activeRouterPath = (route) => {
        return location.pathname === route;
    };

    return (
        <li className="submenu">
            <button
                type="button"
                className="use-section-toggle d-flex justify-content-between"
                onClick={toggleSection}
            >
                <div>
                    {menu.icon}
                    <span>{menu.menuValue}</span>
                </div>
                <span className="menu-arrow">
                    {isOpen ? (
                        <Icon.ChevronDown className="react-feather-custom" />
                    ) : (
                        <Icon.ChevronRight className="react-feather-custom" />
                    )}
                </span>
            </button>
            <ul className={`set-section-content ${isOpen ? 'open' : ''}`}>
                {menu.subMenus.map((subMenu) => (
                    <li key={subMenu.route}>
                        <Link
                            to={subMenu.route}
                            className={`${activeRouterPath(subMenu.route) ? 'active' : ''}`}
                        >
                            {subMenu.menuValue}
                        </Link>
                    </li>
                ))}
            </ul>
        </li>
    );
};

export default ToggleMenuItem;
